import { createSelector } from 'reselect';
import { basicSelector } from './helpers';
export const getCmsSettings = basicSelector(state => {
  return state.cmsSettings;
});
export const getCustomDomainSetupNextReminderDate = createSelector([getCmsSettings], cmsSettings => cmsSettings.customDomainSetupNextReminderDate);
export const getHasDismissedOneClickPublishTour = createSelector([getCmsSettings], cmsSettings => cmsSettings.hasDismissedOneClickPublishTour);
export const getAutotranslationCreatedSuccessMessageHidden = createSelector([getCmsSettings], cmsSettings => cmsSettings.autotranslationCreatedSuccessMessageHidden);